/**
 * PendingPtoBanner — admin/manager-only banner that lists pending PTO
 * requests for the currently-selected employee and lets you Approve / Reject
 * each one inline. Lifted out of TimesheetsView for size.
 */
import { AlertCircle, Check, X } from 'lucide-react';

const smallBtn = (bg, fg, border) => ({
  display: 'inline-flex', alignItems: 'center', gap: 4,
  background: bg, color: fg, border: border ? `1px solid ${border}` : 'none',
  borderRadius: 8, padding: '0.3rem 0.6rem',
  fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer',
});

const PendingPtoBanner = ({ requests, onApprove, onReject }) => {
  if (!requests || requests.length === 0) return null;
  return (
    <div
      data-testid="pending-pto-banner"
      style={{
        background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 14,
        padding: '0.85rem 1.1rem', marginBottom: '1rem',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, color: '#92400e', fontWeight: 600 }}>
        <AlertCircle size={16} /> Pending PTO requests
      </div>
      {requests.map((r) => (
        <div
          key={r.id}
          data-testid={`pto-row-${r.id}`}
          style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0.4rem 0', fontSize: '0.85rem' }}
        >
          <span style={{ color: '#92400e' }}>
            {r.type.toUpperCase()} • {r.startDate} → {r.endDate}
          </span>
          {r.reason && <span style={{ color: '#6b7280' }}>— {r.reason}</span>}
          <div style={{ flex: 1 }} />
          <button
            onClick={() => onApprove(r)}
            data-testid={`approve-pto-${r.id}`}
            style={smallBtn('#10b981', '#fff')}
          >
            <Check size={12} /> Approve
          </button>
          <button
            onClick={() => onReject(r)}
            data-testid={`reject-pto-${r.id}`}
            style={smallBtn('transparent', '#ef4444', '#ef4444')}
          >
            <X size={12} /> Reject
          </button>
        </div>
      ))}
    </div>
  );
};

export default PendingPtoBanner;
